import { withTranslation } from "react-i18next"
import { AiOutlineFile } from "react-icons/ai"
import { BiPhone } from "react-icons/bi"
import { GiAges } from "react-icons/gi"
import { GoMail } from "react-icons/go"
import { IoLocationOutline } from "react-icons/io5"

function InfoPrimaryPatient({t, paciente, cita}){
    //console.log(cita)
    return (
        <>
            {
                paciente?.phone &&
                <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><BiPhone className="mr-2"/></div>
                    <div><span>{paciente?.phone}</span></div>                                            
                </div>
            }
            {
                paciente?.phone2 &&
                <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><BiPhone className="mr-2"/></div>
                    <div><span>{paciente?.phone2}</span></div>                                            
                </div>
            }
            {
                paciente?.email && <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><GoMail className="mr-2"/></div>
                    {paciente && <div><span>{paciente?.email}</span></div> }                                           
                </div>
            }
            {
                paciente?.colombusAddress ? <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><IoLocationOutline className="mr-2"/></div>
                    <div>
                        <span className="d-block">
                            {paciente?.colombusAddress?.roadType?.name} {paciente?.colombusAddress?.streetField1} {paciente?.colombusAddress?.streetField2} {paciente?.colombusAddress?.streetField3}
                        </span>
                        <span className="d-block">
                            {paciente?.colombusAddress?.propertyType?.name} {paciente?.colombusAddress?.unitNumber} {paciente?.colombusAddress?.propertyTypeAdditional?.name} {paciente?.colombusAddress?.propertyNumber}
                        </span>
                    </div>                                            
                </div> :
                <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><IoLocationOutline className="mr-2"/></div>
                    <div>{paciente?.address}</div>
                </div>
            }
            {
                cita?.expediente && <div className="d-flex text-secondary mb-3 font-size-09rem">
                    <div><AiOutlineFile className="mr-2"/></div>
                    <div><span>{t('no_expediente')}: {cita?.expediente}</span></div>                                            
                </div>                                            
            }
            <div className="d-flex text-secondary mb-3 font-size-09rem">
                <div><GiAges className="mr-2"/></div>
                <div><span>Edad: {
                    !cita.ageDTO ? '-' :
                    cita.ageDTO?.years < 1 ? 
                    cita.ageDTO.months < 1 ?
                    `${cita.ageDTO.days} ${cita.ageDTO.days === 1 ? 'día' : 'días'}` :
                    `${cita.ageDTO.months} ${cita.ageDTO.months === 1 ? 'mes' : 'meses'}` :
                    `${cita.ageDTO?.years} ${cita.ageDTO?.years === 1 ? 'año' : 'años'}` 
                }</span></div>
            </div>
        </>
    )
}

export default withTranslation()(InfoPrimaryPatient)